<template>
<div v-if="visibility" class="card-1 p-l-10 p-r-10 p-t-10 p-b-10 m-b-30">

  <div>
    <b-tabs content-class="mt-3" fill>
      <b-tab title="Manual" active>
        <b-row>
          <b-col>
            <section class="input-values">
              <label for="">Set on order</label>
              <b-input-group size="sm" class="mb-2">
                <b-input-group prepend="Incoterm">
                  <b-form-input v-model="bulk.incoterm"></b-form-input>
                </b-input-group>
              </b-input-group>
            </section>
          </b-col>
          <b-col>
            <section class="input-values">
              <label for="">Set on order</label>
              <b-input-group size="sm" class="mb-2">
                <b-input-group prepend="DHL Service">
                  <b-form-input v-model="bulk.dhl_service"></b-form-input>
                </b-input-group>
              </b-input-group>
            </section>
          </b-col>
          <b-col>
            <section class="input-values">
              <label for="">Set on order item</label>
              <b-input-group size="sm" class="mb-2">
                <b-input-group prepend="HS Code">
                  <b-form-input v-model="bulk.hs_code"></b-form-input>
                </b-input-group>
              </b-input-group>
            </section>
          </b-col>

          <b-col>
            <section class="input-values">
              <label for="">Set on order item</label>
              <b-input-group size="sm" class="mb-2">
                <b-input-group prepend="Set Price">
                  <b-form-input v-model="bulk.set_price"></b-form-input>
                </b-input-group>
              </b-input-group>
            </section>
          </b-col>
          
        </b-row>
        <b-row>
          <b-col cols="10">

            <section class="input-values">
              <label for="">Set Package Desc.</label>
              <b-input-group size="sm" class="mb-2">
                <b-input-group prepend="Package Desc">
                  <b-form-input v-model="bulk.package_description"></b-form-input>
                </b-input-group>
              </b-input-group>
            </section>

          </b-col>
          <b-col class="m-t-30">
            <b-overlay  :show="busy" rounded opacity="0.6" spinner-small spinner-variant="primary" class="d-inline-block float-right" @hidden="onHidden">
              <b-button ref="button"  :disabled="busy" variant="primary" @click="bulkUpdateOrderAndItems">
                Update
              </b-button>
            </b-overlay>

          </b-col>
        </b-row>
      </b-tab>
      <b-tab title="Autodetect (Coming soon)">
        <b-list-group class="m-b-20">
          <b-list-group-item>For T-sirts - PKD with incoterm DDU</b-list-group-item>
          <b-list-group-item>For canvas - UK, USA, AUS - PLT with incoterm DDP</b-list-group-item>
          <b-list-group-item>For canvas -  rest country - PPS with incoterm DDU</b-list-group-item>
        </b-list-group>
        <b-button ref="button" :disabled="busy" variant="primary" class="float-right">
          Autofill
        </b-button>
      </b-tab>
    </b-tabs>
  </div>

  <b-form-group>
    <b-form-radio-group id="radio-group-1" v-model="selected" :options="options" name="radio-options" @change="bulkTypeChanged"></b-form-radio-group>
  </b-form-group>

</div>
</template>

<script>
import EventBus from '../../EventBus';
import OrdersService from '../../services/orders.service';

export default {
  props: {
    orders: {
      type: Array,
      default: () => []
    },
    visibility: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      bulk: {
        incoterm: '',
        dhl_service: '',
        hs_code: '',
        set_price: '',
        package_description: ''
      },
      selected: 'all',
      options: [{
          text: 'All Visible',
          value: 'all'
        },
        {
          text: 'Only the selected ones',
          value: 'selected'
        }
      ],
      busy: false,
    }
  },
  mounted(){
    if(this.activeList.value){
       let listOptionThere = this.options.find(option => option.value == 'list')
        if(!listOptionThere){
          this.options.unshift({text: "Active List", value: "list"})
          this.selected = 'list'
        }
    }
  },
  watch: {
    activeList(newValue){
        console.log("List selected")
        if(newValue.value){
           let listOptionThere = this.options.find(option => option.value == 'list')
           if(!listOptionThere){
              this.options.unshift({text: "Active List", value: "list"})
              this.selected = 'list'
           }
        }
    }
  },
  methods: {
    bulkTypeChanged(value) {
      EventBus.$emit('orders.bulk-type-updated', value)
    },
    onHidden() {
      // Return focus to the button once hidden
      this.$refs.button.focus()
    },
    bulkUpdateOrderAndItems() {
      this.busy = true;
      let orders = this.orders.map(order => {
        return order.id
      })

      let items = [];
      this.orders.forEach(order => {
        order.items.forEach(id => {
          items.push(id);
        })
      });



      let data = {
        orders,
        items,
        bulk: this.bulk
      }

      // if the selected is Active List
      if(this.selected == 'list'){
         data.ordersListId = this.activeList.value;
      }

      OrdersService.bulkUpdateOrderAndItems(data).then(response => {
          console.log(response.data)
          this.$toasted.show(response.data.message, {
            action: [{
              text: 'Cancel',
              onClick: (e, toastObject) => {
                toastObject.goAway(0);
              }
            }, ],
            duration: 5000
          });
          EventBus.$emit('orders.bulk-fields-with-items-updated');
        })
        .catch(errors => {
          console.log(errors.response.data);

        })
        .then(() => this.busy = false)

    }
  },
  computed: {
    activeList() {
      return this.$store.state.ordersList.activeList
    },
  }
}
</script>

<style lang="scss" scoped>
.input-values {
  max-width: 1000px;

  .input-group-text {
    background-color: rgb(238, 237, 237);
    padding-left: 4px;
    padding-right: 4px;
  }
}

.input-group {
  border: 0.5px solid rgb(236, 236, 236);
}

.input-values {
  &>label {
    font-size: 13px;
  }
}
</style>
